  <template>
  <div class="custom-actions">
    <button class="button is-success" v-bind:class="{ 'is-loading': isLoading }" @click="itemAction('resolve', rowData, rowIndex)">
      <span class="icon is-small">
        <i class="fa fa-refresh"></i>
      </span>
    </button>
    <button class="button is-primary" v-bind:class="{ 'is-loading': isLoading2 }" @click="itemAction('mark', rowData, rowIndex)">
      <span class="icon is-small">
        <i class="fa fa-check"></i>
      </span>
    </button>
    <button class="button is-danger" v-bind:class="{ 'is-loading': isLoading3 }" @click="itemAction('delete', rowData, rowIndex)">
      <span class="icon is-small">
        <i class="fa fa-times"></i>
      </span>
    </button>
  </div>
</template>

<script>
import axios from 'axios';
import url from '../utils/url';
export default {
  data() {
    return {
      isLoading: false,
      isLoading2: false,
      isLoading3: false
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    itemAction(action, data, index) {
      const self = this;
      if (['init', 'pending', 'success'].includes(data.status)) {
        switch (action) {
          case 'resolve':
            if (['init', 'pending'].includes(data.status)) {
              self.isLoading = true;
              axios({
                url: `support/resolve/${data._id}`,
                baseURL: url,
                headers: {
                  authorization: window.localStorage.getItem('biyadmin')
                },
                method: 'get'
              })
                .then(function(result) {
                  self.isLoading = false;
                  self.$toasted.success('done');
                })
                .catch(function(error) {
                  self.isLoading = false;
                  const message = error.response.data.message
                    ? error.response.data.message
                    : 'There was an error';
                  self.$toasted.error('error');
                });
            } else {
              return;
            }
            break;
          case 'mark':
            self.isLoading2 = true;
            axios({
              url: `support/mark/${data._id}`,
              baseURL: url,
              headers: {
                authorization: window.localStorage.getItem('biyadmin')
              },
              method: 'get'
            })
              .then(function(result) {
                self.isLoading2 = false;
                self.$toasted.success('done');
              })
              .catch(function(error) {
                self.isLoading2 = false;
                const message = error.response.data.message
                  ? error.response.data.message
                  : 'There was an error';
                self.$toasted.error('error');
              });
            break;
          case 'delete':
            self.isLoading3 = true;
            axios({
              url: `support/delete/${data._id}`,
              baseURL: url,
              headers: {
                authorization: window.localStorage.getItem('biyadmin')
              },
              method: 'delete'
            })
              .then(function(result) {
                self.isLoading3 = false;
                self.$toasted.success('done');
              })
              .catch(function(error) {
                self.isLoading3 = false;
                const message = error.response.data.message
                  ? error.response.data.message
                  : 'There was an error';
                self.$toasted.error('error');
              });
            break;
        }
      } else {
        return;
      }
    }
  }
};
</script>

<style>
.custom-actions button.ui.button {
  padding: 8px 8px;
}

.custom-actions button.ui.button > i.icon {
  margin: auto !important;
}
</style>



// WEBPACK FOOTER //
// TransActions.vue?27428fc8